import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
const controller = rpcController("MatrizDistancias");
import { cacheResource, bindResource, addOnInvalidateHandler, invalidateResource } from "kea-resource";

type Entity = models.MatrizDistancias;
type EntityDto = models.MatrizDistanciasDto;
export const  MatrizDistancias = cacheResource({
    /**Obtiene una entidad */
    Get: async (id: number): Promise<EntityDto> => await controller('Get', { id }),

    /**Obtiene todas las entidades filtradas por la zona */
    Query: async (): Promise<EntityDto[]> => await controller('Query', {}),

    /**Agrega una entidad */
    Add: async (entity: Entity): Promise<number> => await controller('Add', {}, entity),

    /**Actualiza la entidad */
    Update: async (entity: Entity): Promise<void> => await controller('Update', {}, entity),

    /**Borra un elemento de la matriz */
    Delete: async (id: number): Promise<void> => await controller('Delete', { id }),

    /**
     * Obtiene los pares de sucursales que faltan
     */
    ParesFaltantes: async (): Promise<models.ParSucursalMatrizDistancia[]> => await controller('ParesFaltantes', {}),

}, {
        Query: true,
        Get: true,
        ParesFaltantes: true
    }, {
        Add: true,
        Update: true,
        Delete: true
    });



// WEBPACK FOOTER //
// ./app/resources/items/matrizdistancias.tsx